// Konstante für CSS-Selektoren
const CSS_SELECTORS = ['[data-lion-tier-benefits-compare]', '[data-lion-tier-overview]']; // Beispiel-Selektoren
const HAS_HEADER = false; // Variable, die angibt, ob die CSV eine Kopfzeile hat

console.log("Translation");

// Funktion zum Laden und Parsen der CSV-Datei
async function loadCSV(filePath) {
    const response = await fetch(filePath);
    const data = await response.text();
    const rows = data.trim().split('\n');
    if (HAS_HEADER) rows.shift();
    return rows.map(row => {
        const [german, english] = row.split(';');
        return { german: german.trim(), english: english };
    });
}

// Funktion zum Ersetzen des Textes in einem Node
function translateText(nodes, translations) {
    nodes.forEach(node => {
        if (node.nodeType === Node.TEXT_NODE) {
            if (node.textContent.includes("10%")) {
                console.log(node.textContent);
            }
            translations.forEach(({ german, english }) => {
                // if (node.textContent.includes("Silver")) {
                //     debugger;
                // }
                // // console.log(german);
                // if (german.includes("Silver Needle") && node.textContent.includes("Silver Needle")) {
                //     debugger;
                // } 
                if (node.textContent.includes(german) || node.textContent.trim().includes(german)) {
                    // console.log("============================");
                    // console.log(node);
                    // console.log(node.textContent);
                    // console.log("1 ->")
                    // console.log(english);
                    node.textContent = node.textContent.replace(german, english);
                }
            });
        } else {
            // // Überprüfen, ob der Node nur Text und <span>-Elemente enthält
            // const childNodes = Array.from(node.childNodes);
            // const containsOnlyTextAndSpans = childNodes.every(child => child.nodeType === Node.TEXT_NODE || (child.nodeType === Node.ELEMENT_NODE && child.tagName.toLowerCase() === 'span'));

            // if (containsOnlyTextAndSpans) {
            //     // let combinedText = node.innerHTML.replace("&nbsp;", " ");
            //     let combinedText = node.innerHTML;
            //     let translateText = false;
            //     // console.log("-", combinedText);

            //     // Build combinedText with textContents of all childNodes
            //     let combinedTextNew = "";
            //     childNodes.forEach(child => {
            //         if (child.nodeType === Node.TEXT_NODE) {
            //             combinedTextNew += child.textContent;
            //         }
            //         if (child.nodeType === Node.ELEMENT_NODE && child.tagName.toLowerCase() === 'span') {
            //             combinedTextNew += child.textContent;
            //         }
            //     });
            //     // console.log(node);
            //     // console.log("combinedTextNew", combinedTextNew);

            //     translations.forEach(({ german, english }) => {
            //         const regex = new RegExp(german.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1").replace(/\s+/g, '\\s*'), 'g');
            //         // console.log(german);
            //         if (regex.test(combinedTextNew)) {
            //             combinedText = combinedText.replace(regex, english);
            //             translateText = true;
            //         }
            //     });
            //     if (translateText) {
            //         console.log("============================");
            //         console.log(node);
            //         console.log("combinedTextNew", combinedTextNew);
            //         console.log(node.innerHTML);
            //         console.log("2 ->")
            //         console.log(combinedText);
            //         node.innerHTML = combinedText;
            //     }
            // } else {
            // }
            translateText(Array.from(node.childNodes), translations);
        }
    });
}

// Hauptfunktion zur Textsuche und -ersetzung
async function translatePage(node = null) {
    const translations_input = await loadCSV('//www.paperandtea.de/cdn/shop/t/340/assets/weglot_replacement.csv?v=116409666099317684051774525245');
    const translations = [];
    translations_input.forEach(({ german, english }) => {
        if (german != "" && german != undefined && english != "" && english != undefined) {
            translations.push({ german: german, english: english });
        }
    });

    // Alle Elemente passend zu den CSS-Selektoren suchen
    let elements = CSS_SELECTORS.flatMap(selector => Array.from(document.querySelectorAll(selector)));
    if (node != null) {
        elements = [node];
    }


    
    // elements.forEach(element => {
    //     // Alle Textbausteine finden
    //     const textNodes = [];
    //     const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, {
    //         acceptNode: node => NodeFilter.FILTER_ACCEPT
    //     });
        
    //     while (walker.nextNode()) {
    //         textNodes.push(walker.currentNode);
    //     }
        
    //     // Opacity der Textbausteine auf 0 setzen
    //     textNodes.forEach(node => {
    //         const parent = node.parentElement;
    //         if (parent) parent.style.opacity = '0';
    //     });
        
    //     // Textbausteine mit der CSV vergleichen und ersetzen
    //     translateText(textNodes, translations);
        
    //     // Opacity für alle Textbausteine wieder auf 1 setzen
    //     textNodes.forEach(node => {
    //         const parent = node.parentElement;
    //         if (parent) parent.style.opacity = '1';
    //     });
    // });

    elements.forEach(element => {
        // Textbausteine mit der CSV vergleichen und ersetzen
        translateText(Array.from(element.childNodes), translations);

        const inputs = element.querySelectorAll('input');
        console.log(inputs);
        inputs.forEach(input => {
            if (input.placeholder) {
                translations.forEach(({ german, english }) => {
                    if (input.placeholder.includes(german)) {
                        input.placeholder = input.placeholder.replace(german, english);
                    }
                });
            }
        });
    });
}

// Funktion zum Einrichten des MutationObserver
function observeMutations() {
    const observerConfig = { childList: true, subtree: true };
    const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
            // console.log("observe");
            mutation.addedNodes.forEach(async node => {
                if (node.nodeType === Node.ELEMENT_NODE) {
                    // console.log("observe - translate");
                    await translatePage(node);
                    await addAccessibilityAttributes(node);
                }
            });
        });
    });
    
    CSS_SELECTORS.forEach(selector => {
        const elements = Array.from(document.querySelectorAll(selector));
        // console.log(selector);
        // console.log(elements);
        elements.forEach(element => {
            observer.observe(element, observerConfig);
        });
    });
}

// Initialisierung des Skripts
window.addEventListener('load', async () => {
    await translatePage();
    observeMutations();
});
